import React from 'react';
import {Button, Col, Row} from "reactstrap";
import "./MailEditorAttach.css";
import ModalAttachments from "../Attach/ModalAttachments/index.tsx";
import AttachIcon from "../../../../../media/images/AttachIcon.mjs";
import TextLabel from "../../../../../Controls/TextLabel.mjs";
import AttachmentList from "../Attach/AttachmentList.mjs";

//const G = window.glob;

const MailEditorAttach = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			message: props.message || {},
			value: props.message?.attachments || []
		};
		this.onChange = this.onChange.bind(this);
		this.toggleSubdialog = this.toggleSubdialog.bind(this);
	}
	toggleSubdialog( s ) {
		if ( typeof s === 'undefined' ) s = ! this.state.showSubdialog;
		this.setState({ showSubdialog: s });
	}
	onChange = (v) => {
		if ( typeof v === 'undefined' ) return;
		const m = this.props.getter();
		if ( v && v.length ) {
			m.attachments = v;
		} else {
			delete m.attachments;
		}
		this.setState( { value: v, message: m });
		this.props.setter( m );
	};
	render() {
		return(
			<Row className={ this.props.error ? 'select error': 'select'}>
				<Col className={"MailEditorAttach"}>
					<div className={"EditorAttachControls"}>
						<Button
							className={"btn-icon"}
							color="primary"
							onClick={(e) => {
								e.preventDefault();
								this.toggleSubdialog(true)
							}}
						>
							<i>
								<AttachIcon/>
							</i>
							<b>
								<TextLabel value={"Attachments"}/>
							</b>
						</Button>
					</div>
					<div
						className={"EditorAttachList"}
						onClick={this.toggleSubdialog}
					>
						<AttachmentList
							summary={true}
							fullWidth={true}
							icon={true}
							size={true}
							attachments={this.state.value}
						/>
					</div>
					<ModalAttachments
						open={this.state.showSubdialog}
						setOpen={this.toggleSubdialog}
						attachments={this.state.value}
						setSavedAttachments={this.onChange}
					/>
				</Col>
			</Row>
		)
	}
};

export default MailEditorAttach;
